import React, { useEffect, useState } from 'react';
import { Play, Clock, BookOpen, Video, ArrowLeft, PenLine } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { subjectColors } from '../utils/constants';
interface Unit {
  title: string;
  totalVideos: number;
  duration: string;
  lectureVideos: number;
  problemVideos: number;
  completed: number;
}
interface Subject {
  id: string;
  title: string;
  image: string;
  units: Unit[];
}
const subjects: Subject[] = [{
  id: 'turkce',
  title: 'Türkçe',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/53920870-2e72-4897-9a68-0d2901d601e4/image_fx__(5).jpg',
  units: [{
    title: 'Sözcükte Anlam',
    totalVideos: 12,
    duration: '3 saat 20 dakika',
    lectureVideos: 8,
    problemVideos: 4,
    completed: 75
  }, {
    title: 'Deyimler ve Atasözleri',
    totalVideos: 10,
    duration: '2 saat 45 dakika',
    lectureVideos: 7,
    problemVideos: 3,
    completed: 60
  }, {
    title: 'Cümlede Anlam',
    totalVideos: 15,
    duration: '4 saat 30 dakika',
    lectureVideos: 10,
    problemVideos: 5,
    completed: 40
  }, {
    title: 'Sözel Mantık / Görsel Okuma',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 20
  }, {
    title: 'Parçada Anlam',
    totalVideos: 14,
    duration: '3 saat 50 dakika',
    lectureVideos: 9,
    problemVideos: 5,
    completed: 30
  }, {
    title: 'Söz Sanatları',
    totalVideos: 6,
    duration: '1 saat 45 dakika',
    lectureVideos: 4,
    problemVideos: 2,
    completed: 0
  }, {
    title: 'Metin Türleri',
    totalVideos: 9,
    duration: '2 saat 30 dakika',
    lectureVideos: 6,
    problemVideos: 3,
    completed: 0
  }, {
    title: 'Noktalama İşaretleri',
    totalVideos: 7,
    duration: '2 saat',
    lectureVideos: 4,
    problemVideos: 3,
    completed: 15
  }, {
    title: 'Yazım Kuralları',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 25
  }, {
    title: 'Fiilimsiler',
    totalVideos: 7,
    duration: '2 saat',
    lectureVideos: 4,
    problemVideos: 3,
    completed: 0
  }, {
    title: 'Cümlenin Öğeleri',
    totalVideos: 10,
    duration: '2 saat 45 dakika',
    lectureVideos: 6,
    problemVideos: 4,
    completed: 0
  }, {
    title: 'Cümle Türleri',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 0
  }, {
    title: 'Anlatım Bozukluğu',
    totalVideos: 6,
    duration: '1 saat 45 dakika',
    lectureVideos: 4,
    problemVideos: 2,
    completed: 0
  }]
}, {
  id: 'matematik',
  title: 'Matematik',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/472f13e1-d5a1-4908-a2f4-ca37914378a1/image_fx__(6).jpg',
  units: [{
    title: 'Çarpanlar ve Katlar',
    totalVideos: 10,
    duration: '2 saat 45 dakika',
    lectureVideos: 6,
    problemVideos: 4,
    completed: 100
  }, {
    title: 'Üslü Sayılar',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 80
  }, {
    title: 'Köklü Sayılar',
    totalVideos: 9,
    duration: '2 saat 30 dakika',
    lectureVideos: 6,
    problemVideos: 3,
    completed: 65
  }, {
    title: 'Veri Analizi',
    totalVideos: 7,
    duration: '2 saat',
    lectureVideos: 4,
    problemVideos: 3,
    completed: 45
  }, {
    title: 'Olasılık',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 30
  }, {
    title: 'Cebirsel İfadeler',
    totalVideos: 11,
    duration: '3 saat',
    lectureVideos: 7,
    problemVideos: 4,
    completed: 20
  }, {
    title: 'Doğrusal Denklemler ve Eğim',
    totalVideos: 12,
    duration: '3 saat 20 dakika',
    lectureVideos: 8,
    problemVideos: 4,
    completed: 10
  }, {
    title: 'Eşitsizlikler',
    totalVideos: 6,
    duration: '1 saat 45 dakika',
    lectureVideos: 4,
    problemVideos: 2,
    completed: 0
  }, {
    title: 'Üçgenler',
    totalVideos: 10,
    duration: '2 saat 45 dakika',
    lectureVideos: 6,
    problemVideos: 4,
    completed: 0
  }, {
    title: 'Eşlik ve Benzerlik',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 0
  }, {
    title: 'Dönüşüm Geometrisi',
    totalVideos: 7,
    duration: '2 saat',
    lectureVideos: 4,
    problemVideos: 3,
    completed: 0
  }, {
    title: 'Geometrik Cisimler',
    totalVideos: 9,
    duration: '2 saat 30 dakika',
    lectureVideos: 6,
    problemVideos: 3,
    completed: 0
  }]
}, {
  id: 'fen',
  title: 'Fen Bilimleri',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/342defcc-7c1d-494c-b44e-30031e1df94e/image_fx__(7).jpg',
  units: [{
    title: 'Mevsimler ve İklim',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 60
  }, {
    title: 'DNA ve Genetik Kod',
    totalVideos: 12,
    duration: '3 saat 20 dakika',
    lectureVideos: 8,
    problemVideos: 4,
    completed: 45
  }, {
    title: 'Basınç',
    totalVideos: 6,
    duration: '1 saat 45 dakika',
    lectureVideos: 4,
    problemVideos: 2,
    completed: 30
  }, {
    title: 'Madde ve Endüstri',
    totalVideos: 15,
    duration: '4 saat 30 dakika',
    lectureVideos: 10,
    problemVideos: 5,
    completed: 20
  }, {
    title: 'Basit Makineler',
    totalVideos: 7,
    duration: '2 saat',
    lectureVideos: 4,
    problemVideos: 3,
    completed: 10
  }, {
    title: 'Enerji Dönüşümleri ve Çevre Bilimi',
    totalVideos: 9,
    duration: '2 saat 30 dakika',
    lectureVideos: 6,
    problemVideos: 3,
    completed: 5
  }, {
    title: 'Elektrik Yükleri ve Elektrik Enerjisi',
    totalVideos: 10,
    duration: '2 saat 45 dakika',
    lectureVideos: 6,
    problemVideos: 4,
    completed: 0
  }]
}, {
  id: 'inkılap',
  title: 'T.C. İnkılap Tarihi ve Atatürkçülük',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/8f55533b-a8d1-414d-95ae-dd4d9212be55/image_fx__(8).jpg',
  units: [{
    title: 'Bir Kahraman Doğuyor',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 70
  }, {
    title: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
    totalVideos: 12,
    duration: '3 saat 20 dakika',
    lectureVideos: 8,
    problemVideos: 4,
    completed: 55
  }, {
    title: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
    totalVideos: 14,
    duration: '3 saat 50 dakika',
    lectureVideos: 9,
    problemVideos: 5,
    completed: 40
  }, {
    title: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
    totalVideos: 10,
    duration: '2 saat 45 dakika',
    lectureVideos: 6,
    problemVideos: 4,
    completed: 25
  }, {
    title: 'Demokratikleşme Çabaları',
    totalVideos: 6,
    duration: '1 saat 45 dakika',
    lectureVideos: 4,
    problemVideos: 2,
    completed: 15
  }, {
    title: 'Atatürk Dönemi Dış Politika',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 5
  }, {
    title: "Atatürk'ün Ölümü ve Sonrası",
    totalVideos: 5,
    duration: '1 saat 30 dakika',
    lectureVideos: 3,
    problemVideos: 2,
    completed: 0
  }]
}, {
  id: 'ingilizce',
  title: 'İngilizce',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/ea67535a-604d-4bf1-9bcd-1b4b904b3521/image_fx__(9).jpg',
  units: [{
    title: 'Friendship',
    totalVideos: 6,
    duration: '1 saat 45 dakika',
    lectureVideos: 4,
    problemVideos: 2,
    completed: 85
  }, {
    title: 'Teen Life',
    totalVideos: 7,
    duration: '2 saat',
    lectureVideos: 4,
    problemVideos: 3,
    completed: 70
  }, {
    title: 'In The Kitchen',
    totalVideos: 5,
    duration: '1 saat 30 dakika',
    lectureVideos: 3,
    problemVideos: 2,
    completed: 60
  }, {
    title: 'On The Phone',
    totalVideos: 6,
    duration: '1 saat 45 dakika',
    lectureVideos: 4,
    problemVideos: 2,
    completed: 45
  }, {
    title: 'The Internet',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 30
  }, {
    title: 'Adventures',
    totalVideos: 7,
    duration: '2 saat',
    lectureVideos: 4,
    problemVideos: 3,
    completed: 20
  }, {
    title: 'Tourism',
    totalVideos: 6,
    duration: '1 saat 45 dakika',
    lectureVideos: 4,
    problemVideos: 2,
    completed: 10
  }, {
    title: 'Chores',
    totalVideos: 5,
    duration: '1 saat 30 dakika',
    lectureVideos: 3,
    problemVideos: 2,
    completed: 5
  }, {
    title: 'Science',
    totalVideos: 9,
    duration: '2 saat 30 dakika',
    lectureVideos: 6,
    problemVideos: 3,
    completed: 0
  }, {
    title: 'Natural Forces',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 0
  }]
}, {
  id: 'din',
  title: 'Din Kültürü ve Ahlâk Bilgisi',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/a58167ac-e09a-4736-bf01-faa35ee6e6a7/image_fx__(10).jpg',
  units: [{
    title: 'Kader İnancı',
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 75
  }, {
    title: 'Bir Peygamber Tanıyorum: Hz. Musa',
    totalVideos: 6,
    duration: '1 saat 45 dakika',
    lectureVideos: 4,
    problemVideos: 2,
    completed: 60
  }, {
    title: 'Zekat ve Sadaka',
    totalVideos: 5,
    duration: '1 saat 30 dakika',
    lectureVideos: 3,
    problemVideos: 2,
    completed: 45
  }, {
    title: 'Din ve Hayat',
    totalVideos: 7,
    duration: '2 saat',
    lectureVideos: 4,
    problemVideos: 3,
    completed: 30
  }, {
    title: "Hz. Muhammed'in Örnekliği",
    totalVideos: 9,
    duration: '2 saat 30 dakika',
    lectureVideos: 6,
    problemVideos: 3,
    completed: 20
  }, {
    title: "Kur'an-ı Kerim ve Özellikleri",
    totalVideos: 8,
    duration: '2 saat 15 dakika',
    lectureVideos: 5,
    problemVideos: 3,
    completed: 10
  }, {
    title: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
    totalVideos: 6,
    duration: '1 saat 45 dakika',
    lectureVideos: 4,
    problemVideos: 2,
    completed: 5
  }, {
    title: 'İslam Dinine Göre Kötü Davranışlar',
    totalVideos: 7,
    duration: '2 saat',
    lectureVideos: 4,
    problemVideos: 3,
    completed: 0
  }, {
    title: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
    totalVideos: 5,
    duration: '1 saat 30 dakika',
    lectureVideos: 3,
    problemVideos: 2,
    completed: 0
  }, {
    title: 'Hac ibadeti',
    totalVideos: 6,
    duration: '1 saat 45 dakika',
    lectureVideos: 4,
    problemVideos: 2,
    completed: 0
  }]
}];
export function Topics() {
  const [selectedSubject, setSelectedSubject] = useState<Subject | null>(null);
  const [subjectsWithProgress, setSubjectsWithProgress] = useState<Subject[]>(subjects);
  const navigate = useNavigate();
  // Load progress from localStorage
  useEffect(() => {
    const topicsProgressString = localStorage.getItem('topicsProgress');
    if (topicsProgressString) {
      const topicsProgress = JSON.parse(topicsProgressString);
      // Update the subjects with progress from localStorage
      const updatedSubjects = subjects.map(subject => {
        const updatedUnits = subject.units.map(unit => {
          const unitKey = `${subject.id}_${unit.title.toLowerCase().replace(/ /g, '-')}`;
          if (topicsProgress[unitKey] !== undefined) {
            return {
              ...unit,
              completed: topicsProgress[unitKey]
            };
          }
          return unit;
        });
        return {
          ...subject,
          units: updatedUnits
        };
      });
      setSubjectsWithProgress(updatedSubjects);
    }
  }, []);
  // Fixed to properly use subject colors from constants
  const getSubjectGradient = (subjectId: string) => {
    const colors = subjectColors[subjectId as keyof typeof subjectColors];
    if (!colors) {
      return {
        from: 'from-purple-600',
        to: 'to-indigo-600'
      };
    }
    return colors;
  };
  const handleUnitClick = (subject: Subject, unit: Unit) => {
    const subjectSlug = subject.id;
    const unitSlug = unit.title.toLowerCase().replace(/ /g, '-');
    navigate(`/topics/${subjectSlug}/${unitSlug}`);
  };
  return <div className="space-y-6" data-id="element-3339">
      <div className="flex items-center gap-4" data-id="element-3340">
        {selectedSubject && <button onClick={() => setSelectedSubject(null)} className="flex items-center gap-2 px-4 py-2 rounded-lg border bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:opacity-90 transition-all" data-id="element-3341">
            <ArrowLeft className="w-5 h-5" data-id="element-3342" />
            Geri
          </button>}
        <h1 className="text-2xl font-bold" data-id="element-3343">
          {selectedSubject ? selectedSubject.title : 'Konu Anlatım'}
        </h1>
      </div>

      {!selectedSubject ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3344">
          {subjectsWithProgress.map(subject => {
        const gradient = getSubjectGradient(subject.id);
        return <div key={subject.id} className={`relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r ${gradient.from} ${gradient.to} group cursor-pointer`} onClick={() => setSelectedSubject(subject)} data-id="element-3345">
                <div className="relative bg-black/90 rounded-lg h-full" data-id="element-3346">
                  <div className="relative aspect-[16/9]" data-id="element-3347">
                    <img src={subject.image} alt={subject.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-3348" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent" data-id="element-3349" />
                    <div className="absolute inset-0 flex items-end justify-center p-8" data-id="element-3350">
                      <h3 className="text-xl font-semibold text-center" data-id="element-3351">
                        {subject.title}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>;
      })}
        </div> : <div className="space-y-4" data-id="element-3352">
          {selectedSubject.units.map((unit, index) => {
        const gradient = getSubjectGradient(selectedSubject.id);
        return <div key={index} className={`relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r ${gradient.from} ${gradient.to} group cursor-pointer hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300`} onClick={() => handleUnitClick(selectedSubject, unit)} data-id="element-3353">
                <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-3354">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-6" data-id="element-3355">
                    <div className="flex-1" data-id="element-3356">
                      <h3 className="text-lg font-semibold mb-4" data-id="element-3357">
                        {unit.title}
                      </h3>
                      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm" data-id="element-3358">
                        <div className="flex items-center gap-2 text-gray-400" data-id="element-3359">
                          <Video className="w-4 h-4" data-id="element-3360" />
                          <span data-id="element-3361">{unit.totalVideos} Video</span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-400" data-id="element-3362">
                          <Clock className="w-4 h-4" data-id="element-3363" />
                          <span data-id="element-3364">{unit.duration}</span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-400" data-id="element-3365">
                          <BookOpen className="w-4 h-4" data-id="element-3366" />
                          <span data-id="element-3367">{unit.lectureVideos} Ders Notu</span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-400" data-id="element-3368">
                          <PenLine className="w-4 h-4" data-id="element-3369" />
                          <span data-id="element-3370">{unit.problemVideos} Soru Çözümü</span>
                        </div>
                      </div>
                    </div>
                    <div className="sm:w-32" data-id="element-3371">
                      <div className="flex justify-between text-sm mb-2" data-id="element-3372">
                        <span className="text-gray-400" data-id="element-3373">Tamamlandı</span>
                        <span className={`${gradient.from.replace('from-', 'text-').split('-')[0]}-400`} data-id="element-3374">
                          {unit.completed}%
                        </span>
                      </div>
                      <div className="h-2 bg-gray-700 rounded-full overflow-hidden" data-id="element-3375">
                        <div className={`h-full bg-gradient-to-r ${gradient.from} ${gradient.to} rounded-full transition-all duration-300`} style={{
                    width: `${unit.completed}%`
                  }} data-id="element-3376" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>;
      })}
          {selectedSubject.units.length === 0 && <div className="text-center py-12 text-gray-400" data-id="element-3377">
              Bu ders için henüz içerik eklenmemiş
            </div>}
        </div>}
    </div>;
}